import { useCallback, useState } from "react";
import { AuthApi } from "../../infrastructure/api/AuthApi";
import { signupUser } from "../useCases/signupUser";
import type { SignupDTO } from "../../domain/dto/SignupDTO";
import type { RegistrationResponse } from "../../domain/entities/RegistrationResponse";

export const useSignup = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const signup = useCallback(
    async (data: SignupDTO): Promise<RegistrationResponse> => {
      setLoading(true);
      setError(null);

      try {
        const repo = new AuthApi();

        const result = await signupUser(repo, data);

        return result;
      } catch (err: unknown) {
        const message =
          err instanceof Error
            ? err.message
            : "Signup failed. Please try again.";

        setError(message);
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [],
  );

  return { signup, loading, error };
};
